<template>
  <div class="content">
    <!-- <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>停车管理</el-breadcrumb-item>
            <el-breadcrumb-item>车库管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row> -->
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center;justify-content:space-between;width:100%">
              <div style="display:flex;align-items:center;margin-right:20px;width:30%;justify-content:space-between;">  
                 <el-select
                   v-model="carportId"
                   clearable
                   filterable
                   placeholder="请选择车库"
                   class="select"
                   @change="search"
                   style="width:200px"
                 >
                   <el-option  v-for="item in cars" :key="item.id" :label="item.name" :value="item.id"></el-option>
                 </el-select>
                <el-input v-model="serchName" placeholder="请输入车牌号" style="width:200px" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
              </div>
              <div style="display:flex;align-items:center;width:10%;justify-content:space-between;">
                
                <el-button
                  v-if="isMenuExit('pro:house.export')"
                  type="primary"      
                  size="mini"
                  style="display:flex;align-items:center"
                  @click="exportInfo()"
                >导出</el-button>
                <el-upload
                  v-if="isMenuExit('pro:house:import')"
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHead"
                  :show-file-list="false"
                  :on-success="handleAppSuccess"
                  :data="uploadData"
                >
                  <el-button type="success" size="mini" icon="el-icon-upload">导入</el-button>
                </el-upload>
              </div>
            </div>
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="tableData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
           <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="编号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="车位编号">
            <template slot-scope="scope">
              <span>{{ scope.row.stallNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="已绑车牌">
            <template slot-scope="scope">
              <span>{{scope.row.bindCarNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column label="月卡/vip">
            <template slot-scope="scope">
              <span>{{ scope.row.carportCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="到期时间">
            <template slot-scope="scope">
              <span>{{scope.row.layerCount}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="车位图">
            <template slot-scope="scope">
              <span>{{scope.row.carportPhoto}}</span>
            </template>
          </el-table-column>-->
          <el-table-column label="车主信息">
            <template slot-scope="scope">
              <span class="color1 hand" v-if="isMenuExit('pro:house:info')" @click="edit( scope.row)">查看</span>
            </template>
          </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
             <el-dialog
          :title="dialogTitle1"
          :visible.sync="imoportVisible"
          center
          :append-to-body="true"
          :before-close="handleClose1"
          :lock-scroll="false"
          width="30%"
        >
          <template>
            <el-table :data="tableData1" style="width: 100%" border>
              <el-table-column label="状态" width="300">
                <template slot-scope="scope">
                  <span v-if="scope.row.status==0">
                    <i class="el-icon-circle-check" style="color:#07C160"></i>
                  </span>
                  <span v-if="scope.row.status==1">
                    <i class="el-icon-warning-outline" style="color:#f00"></i>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="reason" label="原因">
                <template slot-scope="scope">
                  <span v-if="scope.row.status==0" style="color:#07C160">{{scope.row.reason}}</span>
                  <span v-if="scope.row.status==1" style="color:#f00">{{scope.row.reason}}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-dialog>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      tableData: [], //获取数据
      tableData1: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId: '',
      cars: [],
      name: '', //车库名称
      uploadUrl: myHttp.importStallForExcel, //上传地址
      uploadHead: {
        accessToken: util.session.get('token')
      },
      uploadData: {
        stallStatus: '',
        carportId: ''
      },
      carNumber: '', //车牌号
      dataText: '正在加载',
      dialogTitle1:'导入',
      dialogTitle: '',
      userId: '',
      stallStatus: '1', //物业自有车位
      carportId: '',
      imoportVisible: false,
      serchName:''
    }
  },
  mounted() {
    this.projectId = util.session.get('groupId')
    this.userId = util.session.get('user').id
    if (this.projectId == '') {
      this.$store.commit('setGroupId')
      this.projectId = this.$store.state.groupId
    }
    this.getCar()
    ;(this.uploadData.stallStatus = this.stallStatus),
      (this.uploadData.carportId = this.carportId)
    console.log(this.$store.state.token)
  },
  methods: {
    // 获取车库列表
    getCar() {
      var that = this
      // secCarportByLikeNameList
      myHttp
        .secCarportByLikeNameList({
          projectId: this.projectId,
          name: this.name
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.carports || []
              that.cars = list
              that.carportId = that.carportId  ? that.carportId : list.length > 0  ? list[0].id  : ''
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //获取数据
    getData() {
      var that = this
      myHttp
        .secStallByLikeName({
          projectId: this.projectId,
          carportId: this.carportId,
          pageSize: this.pageSize,
          pageNum: this.currentPage,
          stallStatus: this.stallStatus,
          carNumber: this.carNumber
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              // console.log(resp)
              var list = resp.data.data.stalls.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index =
                  that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
              }
              that.tableData = list
              that.totalItems = resp.data.data.stalls.total
              if (list.length == 0) {
                that.dataText = '暂无数据'
              }
              that.uploadData.stallStatus = that.stallStatus
              that.uploadData.carportId = that.carportId
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 编辑弹框
    edit(row) {
      this.dialogTitle = '修改车库'
      this.editFormVisible = true
      this.editForm = {
        name: row.name,
        carportCount: row.carportCount,
        carportPhoto: row.carportPhoto,
        id: row.id
      }
      this.icon =
        row.carportPhoto && row.carportPhoto != ''
          ? base.httpCtx + row.carportPhoto
          : ''
      console.log(this.icon)
    },
    // 导出
    exportInfo() {
      var token = this.$store.state.token
      window.open(
        myHttp.exportStallForExcel +
          '?carNumber=' +
          this.carNumber +
          '&carportId=' +
          this.carportId +
          '&stallStatus=' +
          this.stallStatus +
          '&accessToken=' +
          token
      )
    },
    doFilter() {
      this.getData()
    },
    //
    // handleChange(e) {
    //   this.editForm.useType = e.value
    //   console.log(e.value)
    // },

    //上传成功监听方法
    handleAppSuccess(res, file) {
      if (res.code == '200') {
        this.imoportVisible = true
        this.tableData1 = res.data.list
        this.getData()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleClose1(done) {
      this.imoportVisible = false
    },
    // 上传图片
    handleIconSuccess(res, file) {
      this.icon = URL.createObjectURL(file.raw)
      this.editForm.carportPhoto = res.data.saveUrls
    },
    // 查询
    search(e) {

      this.getData()
      console.log(this.carportId)
    },
    search1(e) {
      this.getData()
    },

    // 关闭弹出框弹窗
    handleClose(done) {
      this.editFormVisible = false
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
  overflow: auto;
  }
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px 10px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.cur {
  background: #ecf5ff !important;
  /* border: 1px solid   #409EFF !important ; */
  color: #409eff !important  ;
}
</style>